/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  Container,
} from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { queryString } from "../../utils/queryString";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../loader/loader";

const CreateVideoProof = () => {
  const [data, setData] = useState({ title: "" });
  const [videoFile, setVideoFile] = useState(null);
  const [errors, setErrors] = useState({ title: "", video: "" });
  const [laoder, setLoader] = useState(false);
  const { id } = queryString();
  const history = useHistory();

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "video") {
      const file = files[0];

      if (file) {
        const validTypes = [
          "video/mp4",
          "video/webm",
          "video/ogg",
          "video/quicktime", // for .mov
        ];

        const validExtensions = [".mp4", ".webm", ".ogg", ".mov"];
        const maxSize = 100 * 1024 * 1024; // 100MB

        const fileTypeValid = validTypes.includes(file.type);
        const fileExtensionValid = validExtensions.some((ext) =>
          file.name.toLowerCase().endsWith(ext)
        );

        if (!fileTypeValid && !fileExtensionValid) {
          setErrors((prev) => ({
            ...prev,
            video: "Unsupported file type. Allowed: MP4, WebM, OGG, MOV, NV.",
          }));
          setVideoFile(null);
          return;
        } else if (file.size > maxSize) {
          setErrors((prev) => ({
            ...prev,
            video: "File too large. Max size is 100MB.",
          }));
          setVideoFile(null);
          return;
        } else {
          setErrors((prev) => ({ ...prev, video: "" }));
          setVideoFile(file);
        }
      }
    } else {
      setData({
        ...data,
        [name]: value,
      });

      if (!value.trim()) {
        setErrors((prev) => ({ ...prev, [name]: "This field is required." }));
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    if (!data.title.trim()) {
      setErrors((prev) => ({ ...prev, title: "Title is required." }));
      hasError = true;
    }

    if (!videoFile && !id) {
      // Only require video file if creating a new proof
      setErrors((prev) => ({ ...prev, video: "Please upload a valid video." }));
      hasError = true;
    }

    if (hasError) return;

    const formData = new FormData();
    formData.append("title", data.title);
    if (videoFile instanceof File) {
      formData.append("video", videoFile);
    }

    setLoader(true);

    try {
      let response;

      if (id) {
        // Update mode
        response = await adminInstance().put(
          `/api/admin/updateSocialProof/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            timeout: 10 * 60 * 1000,
          }
        );
      } else {
        // Create mode
        response = await adminInstance().post(
          "/api/admin/createSocialProof",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            timeout: 10 * 60 * 1000,
          }
        );
      }

      const { code, msg } = response?.data;
      if (code === 200) {
        toast.success(msg, { toastId: "uploadVideo" });
        setData({ title: "" });
        setVideoFile(null);
        history.push("/winners-social-proof");
      } else {
        toast.error("Something went wrong while uploading the video.", {
          toastId: "uploadVideo",
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("An error occurred while uploading the video.");
    }

    setLoader(false);
  };

  const getSingleSocialProof = async () => {
    try {
      const response = await adminInstance().get(
        `/api/admin/getSocialProofById/${id}`
      );
      const { code, data: proofData } = response?.data;

      if (code === 200 && proofData) {
        setData({ title: proofData.title });
        if (proofData.video) {
          const videoUrlParts = proofData.video.split("/");
          const fileWithExt = videoUrlParts[videoUrlParts.length - 1];
          const fileName = fileWithExt.split(".")[0];

          setVideoFile({ name: fileName });
        }
      } else {
        toast.error("Failed to fetch video proof data");
      }
    } catch (error) {
      console.error("Error fetching video proof data:", error);
      toast.error("Error fetching video proof");
    }
  };

  useEffect(() => {
    if (id) {
      setLoader(true);
      getSingleSocialProof().then(() => setLoader(false));
    }
  }, [id]);

  return (
    <Fragment>
      <Breadcrumb title="Create Video Proof" />
      {laoder && <Loader />}
      <Container fluid={true}>
        <Card>
          <CardHeader>
            <h5>Fill the form details</h5>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label for="title">Title</Label>
                <Input
                  type="text"
                  id="title"
                  name="title"
                  value={data.title}
                  onChange={handleChange}
                  invalid={!!errors.title}
                />
                {errors.title && (
                  <small className="text-danger">{errors.title}</small>
                )}
              </FormGroup>

              <FormGroup className="justify-content-start">
                <div className="admin-input col-xl-10 col-md-7">
                  <Label className="col-form-label pt-0">Video</Label>
                  <div className="file-upload">
                    <div className="file-select file_select">
                      <div className="file-select-button">Choose File</div>
                      <div className="file-select-name">
                        {videoFile ? videoFile.name : "No file chosen..."}
                      </div>
                      <input
                        className="form-control"
                        type="file"
                        accept="video/*"
                        name="video"
                        onChange={handleChange}
                      />
                    </div>
                    {errors.video && (
                      <small className="text-danger">{errors.video}</small>
                    )}
                  </div>
                </div>
              </FormGroup>

              <Button disabled={laoder} type="submit" color="primary">
                Upload
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default CreateVideoProof;
